import Vue from 'vue'
import Loading from '@/components/base/Loading'

export function loading(props = {}, delay = 0) {
  const LoadingCtor = Vue.extend(Loading)
  const startTime = Date.now()
  let vm = new LoadingCtor({
    el: document.createElement('div'),
    propsData: props
  })

  document.body.append(vm.$el)
  return function () {
    let currentTime = Date.now()
    let time = currentTime - startTime

    if (delay <= 0 || time > delay) {
      document.body.removeChild(vm.$el)
      vm.$destroy()
    } else {
      setTimeout(() => {
        document.body.removeChild(vm.$el)
        vm.$destroy()
      }, delay - time)
    }
  }
}
